// Compliance Reports Page - Using MUI DataGrid and Bootstrap Modal
import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc, query, orderBy, limit } from "firebase/firestore";
import { db } from "../App";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Modal, Form } from "react-bootstrap";

const ComplianceReports = () => {
  const [reports, setReports] = useState([]);
  const [newReport, setNewReport] = useState({
    reportName: "",
    date: "",
    inspectedBy: "",
    complianceTask: "",
    status: "",
    notes: "",
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchReports = async () => {
      const querySnapshot = await getDocs(collection(db, "compliance_reports"));
      const reportsList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setReports(reportsList);
    };
    fetchReports();
  }, []);

  const generateReportID = async () => {
    const reportQuery = query(collection(db, "compliance_reports"), orderBy("reportID", "desc"), limit(1));
    const querySnapshot = await getDocs(reportQuery);
    if (!querySnapshot.empty) {
      const lastID = querySnapshot.docs[0].data().reportID;
      const newID = parseInt(lastID, 10) + 1;
      return newID.toString().padStart(5, "0");
    } else {
      return "00001";
    }
  };

  const handleAddReport = async () => {
    try {
      const newID = await generateReportID();
      const reportToAdd = { ...newReport, reportID: newID };
      await addDoc(collection(db, "compliance_reports"), reportToAdd);
      setReports([...reports, reportToAdd]);
      setNewReport({
        reportName: "",
        date: "",
        inspectedBy: "",
        complianceTask: "",
        status: "",
        notes: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error("Error adding compliance report: ", error);
    }
  };

  const columns = [
    { field: "reportID", headerName: "Report ID", width: 150 },
    { field: "reportName", headerName: "Report Name", width: 200 },
    { field: "date", headerName: "Date", width: 150 },
    { field: "inspectedBy", headerName: "Inspected By", width: 200 },
    { field: "complianceTask", headerName: "Compliance Task", width: 250 },
    { field: "status", headerName: "Status", width: 150 },
    { field: "notes", headerName: "Notes", width: 250 },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <h2>Compliance Reports</h2>
      
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className="mb-2"
      >
        Add New Report
      </Button>
      
      <div style={{ height: 350, width: 1150 }}>
        <DataGrid
        getRowId={(row) => row.reportName}
          rows={reports}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
          style={{ backgroundColor: "white" }}
        />
      </div>
      
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Report Name</Form.Label>
              <Form.Control
                type="text"
                value={newReport.reportName}
                onChange={(e) => setNewReport({ ...newReport, reportName: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={newReport.date}
                onChange={(e) => setNewReport({ ...newReport, date: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Inspected By</Form.Label>
              <Form.Control
                type="text"
                value={newReport.inspectedBy}
                onChange={(e) => setNewReport({ ...newReport, inspectedBy: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Compliance Task</Form.Label>
              <Form.Control
                type="text"
                value={newReport.complianceTask}
                onChange={(e) => setNewReport({ ...newReport, complianceTask: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control
                type="text"
                value={newReport.status}
                onChange={(e) => setNewReport({ ...newReport, status: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={newReport.notes}
                onChange={(e) => setNewReport({ ...newReport, notes: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddReport}>
            Save Report
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ComplianceReports;